module.exports = __webpack_public_path__ + "img/QH.55ffe26a.png";